import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

interface RootProps {
    indent?: number;
    empty?: boolean;
    number?: boolean;
    horizontalAlign?: "center" | "left" | "right";
}

export const Root = styled.td<RootProps>(
    props => ({
        color: theme(props).typography.secondary.color,
        paddingLeft: props.indent != undefined && isFinite(props.indent) ? 12 + props.indent * 12 : undefined,
        textAlign: props.horizontalAlign,
    }),
    props =>
        props.empty && {
            textAlign: "center",
            lineHeight: "30px",
        },
    props =>
        props.number && {
            textAlign: "center",
        }
);

export const BaselineHackText = styled.span({
    lineHeight: "34px",
});
